import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "..";
import { useState } from "react";

export const useStakeHolder = ({ projectId, isRemovePagination = false }: { projectId: string | undefined, isRemovePagination?: boolean }) => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);

    const changePage = (newPage: number) => {
        setPage(newPage);
    };

    const changeRowsPerPage = (newLimit: number) => {
        setPage(1);
        setLimit(newLimit);
    };

    const { data, isFetching, isPending, isError } = useQuery({
        queryKey: ["project-stake-holder", projectId, page, limit],
        queryFn: () => projectDetailsApi.fetchProjectStakeHolderDetails({ projectId, page: page, limit: isRemovePagination ? 1000 : limit }),
        enabled: !!projectId,
    });

    return {
        stakeHolderData: data?.data?.rows,
        stakeHolderDataPagination: data?.data?.pagination,
        isPending, isFetching, isError,
        changePage, changeRowsPerPage
    }

}